export default __webpack_public_path__ + "static/media/logout.511898fa.svg";